import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const IndexScaleMedium = hoc(
    (props: IconProps) => (
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g>
                <circle cx={12} cy={12} r={12} fill="white" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 19.1355C15.866 19.1355 19 15.9688 19 12.0625C19 8.15628 15.866 4.98962 12 4.98962C8.13401 4.98962 5 8.15628 5 12.0625C5 15.9688 8.13401 19.1355 12 19.1355Z"
                    stroke="#60BF63"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.66668 9.94055C9.79555 9.94055 9.90002 10.0461 9.90002 10.1763C9.90002 10.3065 9.79555 10.4121 9.66668 10.4121C9.53782 10.4121 9.43335 10.3065 9.43335 10.1763C9.43335 10.0461 9.53782 9.94055 9.66668 9.94055"
                    stroke="#60BF63"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.3333 9.94055C14.4622 9.94055 14.5666 10.0461 14.5666 10.1763C14.5666 10.3065 14.4622 10.4121 14.3333 10.4121C14.2044 10.4121 14.1 10.3065 14.1 10.1763C14.1 10.0461 14.2044 9.94055 14.3333 9.94055"
                    stroke="#60BF63"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.7633 13.9487C15.0543 15.3944 13.5956 16.309 11.9988 16.309C10.4021 16.309 8.94332 15.3944 8.23438 13.9487"
                    stroke="#60BF63"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    ),
    'Index'
);
export default IndexScaleMedium;
